<template>
  <div class="list">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <div class="leftSection flex-row flex__left">
        <div
          class="theTitle theTitle__lv1 flex-row flex__left clickable"
          @click="doSort('quote')"
        >
          Trích yếu
          <sort-caret :order="order" :sort="sort" :field="'quote'"/>
        </div>
      </div>
      <div class="rightSection flex-row flex__right">
        <slot name="headerRightSection"></slot>
      </div>
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="perfectScrollbarSetting"
      infinite-wrapper
    >
      <div class="list-docs">
        <div
          v-for="(item, $itemIndex) in incomingDocs"
          v-bind:key="$itemIndex"
          :class="[
            'item flex-row flex__between',
            !item.isSeen ? 'is-seen' : ''
          ]"
          @click="viewDetail(item)"
        >
          <div class="leftSection flex-row flex__left">
            <div class="theTitle__lv5">
              <div class="flex-row flex__left stt">
                <div class="section-check">
                  <span class="stt flex-row flex__center">{{
                    $itemIndex + 1
                  }}</span>
                </div>
                <i
                  @click.stop="downloadAttachment(item)"
                  class="clickable color__smoke fas fa-file"
                ></i>
              </div>
            </div>
            <div class="theTitle__lv1 margin-right-10">
              <div class="title-docs flex-col flex__left">
                <div class="tt_1 clickable" v-bind:class="textBold(item)">
                  {{ item.quote }}
                </div>
                <div class="tt_2 flex-row flex__left margin-top-10">
                  <span v-if="item.docCode"
                  >{{ item.docCode }}&nbsp;&nbsp;</span
                  >
                  <el-tag
                    v-if="item.docTypeName"
                    size="mini"
                    :class="['priority', 'lv3']"
                  >{{ item.docTypeName }}
                  </el-tag>

                  <el-tag
                    v-if="isShowPriority(item.priorityId)"
                    size="mini"
                    :class="['priority', getPiorityClass(item.priorityId)]"
                  >
                    <i class="fas fa-bolt"></i>
                    <span>
                      {{ item.priorityName }}
                    </span>
                  </el-tag>

                  <vb-process-type-tag
                    v-if="item.vbDocProcessType != null"
                    :processType="item.vbDocProcessType"
                  ></vb-process-type-tag>

                  <el-tag
                    size="mini"
                    class="priority lv2"
                    v-if="isAutoBcc(item)"
                  >
                    <i class="fas fa-exclamation-triangle"></i>
                    {{ item.vbDocBccInfoId ? "BCC-DT" : "BCC" }}
                  </el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="rightSection flex-row flex__right">
            <slot name="rowRightSection" :item="item"></slot>
          </div>
        </div>

        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
          force-use-infinite-wrapper=".el-table__body-wrapper"
        >
          <div slot="no-more"></div>
          <div slot="no-results">Không có dữ liệu</div>
        </infinite-loading>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>
<script>
  import InfiniteLoading from "vue-infinite-loading";
  import constants from "../../constants";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import SortCaret from "../doc-out/SortCaret";
  import VbProcessTypeTag from "./vb-process-type-tag";
  import QuahanTime from "../doc-out/quahan-time";

  export default {
    name: "vb-den-table-template",
    props: ["order", "sort", "incomingDocs"],
    components: {
      SortCaret,
      VbProcessTypeTag,
      InfiniteLoading,
      VuePerfectScrollbar,
      QuahanTime
    },

    data() {
      return {};
    },

    created() {
    },

    computed: {
      status() {
        return [constants.DOC_USER_STATUS.DA_XU_LY];
      },
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      }
    },

    watch: {
      isOpenTransferDialog(newValue) {
        newValue && (this.isEnableTransferDialog = newValue);
      },

      isEnableTransferDialog(newValue) {
        !newValue && (this.selectedDoc = null);
      },

      isOpenThuHoiDialog(newValue) {
        newValue && (this.isEnableThuHoiDialog = newValue);
      },

      isEnableThuHoiDialog(newValue) {
        !newValue && (this.selectedDoc = null);
      }
    },

    methods: {

      doSearch() {
        this.$nextTick(
          () =>
            this.$refs.infiniteLoading &&
            this.$refs.infiniteLoading.stateChanger.reset()
        );
      },

      textBold(event) {
        if (event.hasOwnProperty("isSeen")) {
          if (event.isSeen === 1) return "";
          else return "text-bold";
        } else return "";
      },

      infiniteHandler($state) {
        this.$emit("infiniteHandler", {state: $state});
      },

      isAutoBcc(item) {
        return (
          item.relationType === constants.VB_DOC_USER.RELATION_TYPE.NGUOI_DUOC_BCC
        );
      },

      getPiorityClass(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) !== -1
          ? "lv1"
          : "lv4";
      },

      isShowPriority(id) {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) !== -1;
      },

      downloadAttachment(item) {
        this.$emit("downloadAttachment", {item});
      },

      doSort(sort) {
        this.$emit("doSort", {sort});
      },

      viewDetail(item) {
        this.$emit("viewDetail", {item: item});
      }
    }
  };
</script>
<style scoped>
  #searchBox {
    position: relative;
    width: 100%;
  }

  .advance-search {
    font-size: 17px;
    color: #005eb1;
    position: absolute;
    right: 5%;
    top: 50%;
    transform: translateY(-50%);
  }

  .icon-very__small {
    height: 14px;
    padding-top: 4px;
  }

  .icon-info {
    background-color: #f0c330;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    margin-top: -1px;
    margin-left: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/vb-den-table-template.vue